<template>
  <div class="UpdateLoaderLyric">
    <div class="wrapper">
      <h1 class="title">Importuję piosenkę</h1>
      <p class="lyric-name">{{this.dataLoading.loadingName}}</p>
      <p class="status" v-if="this.dataLoading.loadingName">{{this.dataLoading.loadingOrder}}
      z {{this.dataLoading.numOfFiles}}</p>
      <div class="loading-bar">
        <div class="bar-wrapper">
          <div class="bar" :class="calculate"></div>
          <div class="progress-bar" id="calc"></div>
        </div>
        <span class="percent">{{this.loadingStatus}}%</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateLoaderLyric",
  props: {
    dataLoading: {
      type: Object,
    }
  },
  data() {
    return {
      loadingStatus: 0,
    }
  },
  mounted() {
    if (this.dataLoading.files.length) {
      this.calculatePercentage()
    }
  },
  computed: {
    calculate () {
      return {
        'pertage': this.loadingStatus + 'px'
      }
    }
  },
  watch: {
    'dataLoading.loadingOrder' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.calculatePercentage()
      }
    }
  },
  methods: {
    calculatePercentage () {
      this.loadingStatus = ((this.dataLoading.loadingOrder / this.dataLoading.numOfFiles) * 100).toFixed()
      document.getElementById('calc').style.width = this.loadingStatus + '%'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.UpdateLoaderLyric {
  position: absolute;
  width: 600px;
  height: 250px;
  top: 375px;
  left: 50%;
  background-color: black;
  border: 1px solid $primary;
  border-radius: 5px;
  transform: translate(-50%,-50%);
  z-index: 10;

  .wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .title {
      font-size: 20px;
      font-weight: 400;
      margin-bottom: 0;
    }

    .lyric-name {
      margin-top: 0;
      font-size: 22px;
    }

    .status {
      margin-top: 0;
      margin-bottom: 50px;
      color: $primary;
    }

    .loading-bar {
      display: flex;
      flex-direction: column;
      width: 75%;

      .bar-wrapper {
        position: relative;

        .bar {
          position: absolute;
          width: 100%;
          height: 2px;
          background-color: $dark-text;
        }

        .progress-bar {
          position: absolute;
          transform: translateY(-2px);
          content: " ";
          width: 0px;
          background-color: $primary;
          border-radius: 1px;
          height: 5px;
          transition: 1s ease-in;
        }
      }

      .percent {
        padding-left: 20px;
        margin-top: 15px;
      }
    }
  }
}

  @media screen and (max-width: $phone-max-width) {
    .UpdateLoaderLyric {
      width: 90%;
    }
  }

</style>